import { Box } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { cn } from "../lib/utils";

type ComponentProps = {
	children: ReactNode;
};

export const BrandTabButton = (
	props: ComponentProps & { active?: boolean; onClick?: () => void },
) => {
	return (
		<Box
			onClick={props.onClick}
			className={cn(
				"flex items-center justify-center py-2 px-3 rounded-lg",
				props.active
					? "bg-brand-700 hover:bg-brand-600 text-white"
					: "bg-gray-50 hover:bg-gray-100 text-gray-900",
			)}
		>
			{props.children}
		</Box>
	);
};

export const BrandTabButtonClear = (
	props: ComponentProps & { active?: boolean; onClick?: () => void },
) => {
	return (
		<Box
			onClick={props.onClick}
			className={cn(
				"flex items-center justify-center py-2 px-3 rounded-lg",
				props.active
					? "bg-white text-gray-900"
					: "bg-gray-50 hover:bg-gray-100 text-gray-900",
			)}
		>
			{props.children}
		</Box>
	);
};

export const BrandTabSwitcher = (props: ComponentProps) => {
	return (
		<Box className="flex flex-row items-center p-1 gap-1 bg-gray-50 rounded-lg">
			{props.children}
		</Box>
	);
};
